import {
  LOADING_COMPANYWARD,
  LOAD_COMPANYWARD,
  COMPANYWARD_SAVE_REQUEST,
  COMPANYWARD_SAVE_SUCCESS,
  FETCH_COMPANYWARD_REQUEST,
  FETCH_COMPANYWARD_REQUEST_SUCCESS,
  FETCH_COMPANYWARD_COMPANY_LIST_REQUEST_SUCCESS,
} from "../types/companyward.types";
import { ICompany } from "./company.reducer";

export interface ICompanyWard {
  facility_active: boolean;
  facility_address: string;
  facility_contact_email: string;
  facility_contact_number: string;
  facility_contact_person: string;
  facility_latlang: null | string;
  facility_name: string;
  facility_status: boolean;
  id: string;
  parent: string;
  parent_nodes: ICompany[];
}

export type companyWardStateType = {
  companywards: null | ICompanyWard[];
  ward: null | ICompanyWard;
  total: number;
  current: number;
  loading: boolean;
  save: boolean;
  companylist: null | ICompany[];
};

const initialState: companyWardStateType = {
  companywards: null,
  ward: null,
  total: 0,
  current: 1,
  loading: false,
  save: false,
  companylist: null,
};

export default function companywardReducer(state = initialState, action: any) {
  switch (action.type) {
    case LOAD_COMPANYWARD:
      return {
        ...state,
        loading: false,
        companywards: action.payload.results,
        total: action.payload.count,
        current: action.payload.current,
      };
    case LOADING_COMPANYWARD:
    case FETCH_COMPANYWARD_REQUEST:
      return {
        ...state,
        ward: null,
        loading: true,
      };
    case COMPANYWARD_SAVE_REQUEST:
      return {
        ...state,
        save: false,
      };
    case COMPANYWARD_SAVE_SUCCESS:
      return {
        ...state,
        save: true,
        ward: null,
      };
    case FETCH_COMPANYWARD_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        ward: action.payload,
      };
    case FETCH_COMPANYWARD_COMPANY_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        companylist: action.payload,
      };
    default:
      return state;
  }
}
